
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hard",
      function () {
        return require("private-next-pages/hard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hard"])
      });
    }
  